<template>
  <span>{{ label }}</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { AccountType } from '.';

export default defineComponent({
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    label(): string|undefined {
      return AccountType.toString(this.value);
    },
  },
});
</script>
